import React, { useState, useEffect } from "react";
import { useTheme } from "../../hooks/useTheme";
import styles from "./LoadingScreen.module.css";

import loadingBackNight from "../icons/Loader/loaderBackNight.png";
import loadingBackDay from "../icons/Loader/loaderBackDay.png";
import loadingLogo from "../icons/Loader/loaderLogo.png";
import loadingCar from "../icons/Loader/loaderCar.png";

interface LoadingScreenProps {
  onComplete: () => void;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ onComplete }) => {
  const { theme } = useTheme();
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [startTime] = useState(Date.now());
  // Предзагружаем все изображения
  useEffect(() => {
    const imagesToPreload = [
      loadingBackNight,
      loadingBackDay,
      loadingLogo,
      loadingCar,
    ];

    const preloadImage = (src: string) => {
      return new Promise<void>((resolve) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => resolve();
        img.src = src;
      });
    };

    Promise.all(imagesToPreload.map(preloadImage)).then(() => {
      setImagesLoaded(true);
      setTimeout(() => {
        setShowContent(true);
      }, 0);
    });
  }, []);

  useEffect(() => {
    if (imagesLoaded && showContent) {
      const elapsed = Date.now() - startTime;
      const remainingTime = Math.max(3000 - elapsed, 0);

      const timer = setTimeout(() => {
        onComplete();
      }, remainingTime);

      return () => clearTimeout(timer);
    }
  }, [imagesLoaded, showContent, onComplete, startTime]);

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.dark : styles.light
      } ${showContent ? styles.visible : styles.hidden}`}
    >
      {/* Фон со срезами - движется */}
      <div
        className={`${styles.backgroundLayer} ${
          showContent ? styles.backgroundContinuous : ""
        }`}
      >
        <img
          src={theme === "dark" ? loadingBackNight : loadingBackDay}
          alt="Фон"
          className={styles.backgroundImage}
        />
      </div>

      {/* Логотип - статичный */}
      <div className={styles.logo}>
        <img
          src={loadingLogo}
          alt="ДПС Контроль"
          className={styles.logoImage}
        />
      </div>

      {/* Машина - параллакс */}
      <div
        className={`${styles.car} ${showContent ? styles.carContinuous : ""}`}
      >
        <img src={loadingCar} alt="Машина" className={styles.carImage} />
      </div>
    </div>
  );
};
